import { ToastRegionSharedProps } from "@certn/cascadia/components/toast/types";
import { css } from "@emotion/css";
import type { AriaToastRegionProps } from "@react-aria/toast";
import { useToastRegion } from "@react-aria/toast";
import { useRef } from "react";

import { Toast } from "./Toast";
import { mq } from "../utils";

interface Props extends AriaToastRegionProps, ToastRegionSharedProps {}

export function ToastRegion(props: Props) {
  const { state, ...rest } = props;

  const ref = useRef(null);
  const { regionProps } = useToastRegion(rest, state, ref);

  const currentToast = state.visibleToasts[0];

  return (
    <div {...regionProps} ref={ref} className={styles.toastRegion}>
      <Toast key={currentToast.key} toast={currentToast} state={state} />
    </div>
  );
}

const styles = {
  toastRegion: css(
    {
      position: "fixed",
      left: "var(--space-6)",
      right: "var(--space-6)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      pointerEvents: "none",
      outline: "none",
      zIndex: 100,
    },
    mq({
      bottom: ["var(--space-4)", "var(--space-6)"],
    })
  ),
};
